<template>
  <div class="highchart-container">
    <highcharts
      class="runtime-chart"
      :options="runtimeGraphOptions"
    />
  </div>
</template>
<script>
import moment from 'moment';

import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'HumidityGraph',
  mixins: [customerDetailMixin, unitPreferencesMixin],
  computed: {
    graphData() {
      const columnDate = [];
      const allDevices = {};
      let maxTempLimit = -1;
      this.sensors.forEach((sensor) => {
        const {
          deviceId,
          uid,
          sensorType,
        } = sensor;
        const [selectedUid] = this.activeTZoneFilter.split('-');
        if (uid === selectedUid
          && (sensorType === 'A2RoomTempHumidity')) {
          allDevices[deviceId] = {
            avgTemp: [],
            minTemp: [],
            maxTemp: [],
          };
        }
      });
      this.runtimeGraphData.forEach((c, idx) => {
        const {
          localDate,
          temps,
        } = c;
        columnDate.push(localDate);
        if (temps) {
          Object.keys(temps).forEach(((t) => {
            if (allDevices[t]) {
              const {
                avg,
                min,
                max,
              } = temps[t];
              allDevices[t].avgTemp.push(avg);
              allDevices[t].minTemp.push(min);
              allDevices[t].maxTemp.push(max);
              if (max > maxTempLimit) {
                maxTempLimit = max;
              }
            }
          }));
        }
        Object.keys(allDevices).forEach((key) => {
          if (allDevices[key].avgTemp.length < idx + 1) {
            allDevices[key].avgTemp.push(null);
          }
          if (allDevices[key].minTemp.length < idx + 1) {
            allDevices[key].minTemp.push(null);
          }
          if (allDevices[key].maxTemp.length < idx + 1) {
            allDevices[key].maxTemp.push(null);
          }
        });
      });
      return {
        columnDate,
        allDevices,
        maxTempLimit,
      };
    },
    runtimeGraphOptions() {
      const {
        dateFormat,
        tempFormat,
      } = this;
      const {
        columnDate,
        allDevices,
        maxTempLimit,
      } = this.graphData;

      const series = [];

      Object.keys(allDevices).forEach((key) => {
        const {
          avgTemp,
          minTemp,
          maxTemp,
        } = allDevices[key];
        series.push({
          name: `Sensor-${key} Avg Temp`,
          data: avgTemp,
        });
        series.push({
          name: `Sensor-${key} Min Temp`,
          data: minTemp,
        });
        series.push({
          name: `Sensor-${key} Max Temp`,
          data: maxTemp,
        });
      });

      return {
        chart: {
          zoomType: 'x',
          height: 400,
          backgroundColor: '#0f1734',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Room Temperature',
          style: {
            color: 'white',
          },
        },
        tooltip: {
          useHTML: true,
          nullFormat: 'Value is not available.',
          formatter() {
            const s = this.series.name;
            if (s === ' ' && this.y === 0) {
              return 'No cycle Detection';
            }

            return `${this.x}<br/>`
              + `${this.series.name}: <b>${this.y}</b>`;
          },
        },
        xAxis: [{
          categories: columnDate,
          title: {
            text: 'Days',
            style: {
              color: 'white',
            },
          },
          labels: {
            formatter() {
              const label = this.value;
              const format = dateFormat === 'M/D' ? 'M/D/YY' : 'D/M/YY';
              return moment(label)
                .format(format);
            },
            style: {
              color: 'white',
            },
          },
        }],
        yAxis: [
          {
            labels: {
              format: `{value}${tempFormat}`,
              style: {
                color: 'white',
              },
            },
            title: {
              text: 'Temperature',
              style: {
                color: 'white',
              },
            },
            min: 0,
            max: tempFormat !== '°F' ? this.convertToCelsius(maxTempLimit + 20) : maxTempLimit + 20,
          },
        ],
        legend: {
          itemStyle: {
            color: 'white',
          },
          shadow: false,
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
        },
        plotOptions: {
          column: {
            stacking: 'normal',
          },
        },
        series,
      };
    },
  },
};
</script>
